<template>
  <Billing class="billing-report" />
</template>

<script>
import Vue from 'vue';
import '@progress/kendo-ui/js/kendo.core';
import '@progress/kendo-ui/js/kendo.userevents';
import '@progress/kendo-ui/js/kendo.selectable';
import '@progress/kendo-ui/js/kendo.calendar';
import '@progress/kendo-ui/js/kendo.multiviewcalendar';
import '@progress/kendo-ui/js/kendo.popup';
import '@progress/kendo-ui/js/kendo.datepicker';
import '@progress/kendo-ui/js/kendo.daterangepicker';
import '@progress/kendo-ui/js/kendo.button';
import { DateinputsInstaller, DateRangePicker } from '@progress/kendo-dateinputs-vue-wrapper';
import { Button, ButtonsInstaller } from '@progress/kendo-buttons-vue-wrapper';
import { formatDate } from '@telerik/kendo-intl';

import GridDataService from 'services/grid-data.service';
import Constants from '../../constants/constants';

Vue.use(ButtonsInstaller);
Vue.use(DateinputsInstaller);

const Billing = Vue.component('Billing', {
  name: 'Billing',
  data() {
    return {
      ...Constants.BillingReport,
    };
  },
  methods: {
    dateChange(e) {
      this.$nextTick(() => {
        this.range = e.sender._range;
      });
    },
    exportExcel() {
      const searchParams = new URLSearchParams();

      searchParams.append('startDate', formatDate(this.range.start, 'yyyy-MM-dd'));
      searchParams.append('endDate', formatDate(this.range.end, 'yyyy-MM-dd'));

      location.assign(`${Constants.Api.Endpoint.BillingReport.data}?${searchParams.toString()}`);
    },
  },
  template: `
  <div>
      <h2 class="title">{{ title }}</h2>
      <kendo-daterangepicker
        :format="dateRange.format"
        :range="dateRange.range"
        :max="dateRange.max"
        :min="dateRange.min"
        @open="dateChange"
        @close="dateChange">
      </kendo-daterangepicker>
      <kendo-button class="k-primary" @click="exportExcel">Save Report</kendo-button>
    </div>
  `,
});

export default {
  name: 'BillingReport',
  components: {
    Billing,
  },
};
</script>

<style lang="scss" scoped>
.billing-report {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 50px auto;
  width: 400px;

  :deep(.title) {
    flex: 1 1 auto;
    margin: 5px;
    text-align: center;
  }

  :deep(.k-daterangepicker) {
    display: flex;
    flex: 1 1 auto;
    justify-content: space-between;

    .k-textbox-container {
      margin: 10px;
    }
  }

  :deep(.k-button) {
    flex: 1 1 auto;
    margin: 10px;
  }
}
</style>
